import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUS_STYLES = {
    pending: "border-[hsl(var(--ink))] text-[hsl(var(--ink))]",
    approved: "border-[hsl(var(--success))] text-[hsl(var(--success))]",
    declined: "border-[hsl(var(--danger))] text-[hsl(var(--danger))]",
};

export default function AdminBuildClub() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/build-club").then(({ data }) => setItems(data.items));
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try { await api.patch(`/admin/build-club/${id}`, { status }); toast.success(`Marked ${status}`); load(); }
        catch { toast.error("Failed"); }
    };

    return (
        <div data-testid="admin-build-club">
            <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Program</div>
            <h1 className="mt-1 font-display text-4xl uppercase italic text-[hsl(var(--ink))]">Sponsored Build Club</h1>
            <div className="mt-6 space-y-3">
                {items.length === 0 && (
                    <div className="border-2 border-dashed border-[hsl(var(--dust-300))] p-8 text-center text-[hsl(var(--ink-soft))]">
                        No applicants yet.
                    </div>
                )}
                {items.map((c) => (
                    <div key={c.id} className={`border-2 bg-card p-5 ${c.status === "declined" ? "opacity-60" : ""} border-[hsl(var(--ink))]`} data-testid={`build-club-row-${c.id}`}>
                        <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                                <div className="font-heading text-base uppercase text-[hsl(var(--ink))]">{c.name}</div>
                                <div className="font-mono-brand text-xs text-[hsl(var(--ink-soft))]">
                                    {c.email} · rig: {c.rig || "—"} {c.instagram && `· ${c.instagram}`} · {new Date(c.created_at).toLocaleString()}
                                </div>
                            </div>
                            <div className="flex flex-wrap gap-2">
                                <span className={`border px-2 py-1 font-mono-brand text-[10px] uppercase ${STATUS_STYLES[c.status] || STATUS_STYLES.pending}`}>{c.status}</span>
                                {["approved", "declined", "pending"].filter((s) => s !== c.status).map((s) => {
                                    const label = s === "pending" ? "reopen" : s === "approved" ? "approve" : "decline";
                                    return (
                                        <button
                                            key={s}
                                            onClick={() => setStatus(c.id, s)}
                                            className="border border-[hsl(var(--ink))] px-3 py-1 font-heading text-xs uppercase tracking-wider hover:bg-[hsl(var(--ink))] hover:text-[hsl(var(--dust-50))]"
                                            data-testid={`build-club-${label}-${c.id}`}
                                        >
                                            {s === "pending" ? "Reopen" : s}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                        {c.why && <p className="mt-3 whitespace-pre-wrap text-sm text-[hsl(var(--ink))]">{c.why}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
}
